import React, {useEffect, useState} from 'react';
import './App.css';
import {instance} from "./networking/axios";
import axios, {AxiosResponse} from "axios";
import {IOptionsContainer, ISession} from "./networking/Options";
import {IB2CInfo} from "./mainscreen/model/B2CInfo";
import smoothscroll from 'smoothscroll-polyfill';
import MainScreen from './mainscreen/MainScreen';
export interface IAppInfo {
    session?: ISession
    b2cInfo: IB2CInfo
}

export const AppContext = React.createContext<IAppInfo | undefined>(undefined);

function App() {
    const [info, setInfo] = useState<IAppInfo>();
    smoothscroll.polyfill()

    useEffect(() => {
        const settingsParams = new URLSearchParams();
        settingsParams.append('key', 'b2c_web_info');

        const sessionParams = new URLSearchParams();
        sessionParams.append('multi_sessions', "1");

        const sessionRequest = instance.get('/external/sessions/current', {params: sessionParams}).catch((r) => null);
        const settingsRequest = instance.get('/api/fake/settings/list', {params: settingsParams});

        axios.all([sessionRequest, settingsRequest]).then((responses: (AxiosResponse | null)[]) => {
            const session = (responses[0] as AxiosResponse<ISession>)?.data;
            const settings = (responses[1] as AxiosResponse<IOptionsContainer>).data;

            setInfo({session: session, b2cInfo: settings.options.b2c_web_info});
        });
    }, []);

    if (info != null) {
        return <div className="App">
            <AppContext.Provider value={info}>
                <MainScreen b2cInfo={info.b2cInfo} session={info.session}/>
            </AppContext.Provider>
        </div>
    } else {
        return <div/>
    }
}

export default App;
